const GET_MEMBER_FOLLOWED_REQUEST = 'GET_MEMBER_FOLLOWED_REQUEST';
const GET_MEMBER_FOLLOWED_SUCCESS = 'GET_MEMBER_FOLLOWED_SUCCESS';
const GET_MEMBER_FOLLOWED_FAILURE = 'GET_MEMBER_FOLLOWED_FAILURE';
export const NEW_MEMBER_FOLLOWED = 'NEW_MEMBER_FOLLOWED';

const initState = {
    list: [],
    totalCount: 0
};

import * as backend from 'backend-helpers/memberFollowed';

export default function memberFollowed(state = initState, action) {
    switch (action.type) {
        case GET_MEMBER_FOLLOWED_SUCCESS:
            const {list, totalCount} = action.result.data.followers;
            return {
                ...state,
                totalCount,
                list
            };

        case NEW_MEMBER_FOLLOWED:
            return {
                ...state,
                totalCount: ++state.totalCount,
                list: [action.data, ...state.list],
            };

        default:
            return state;
    }
}

export function getMemberFollowed(data) {
    return {
        types: [GET_MEMBER_FOLLOWED_REQUEST, GET_MEMBER_FOLLOWED_SUCCESS, GET_MEMBER_FOLLOWED_FAILURE],
        promise: backend.getMemberFollowed(data),
        data
    }
}

export function newMemberFollowed(data) {
    return {
        type: NEW_MEMBER_FOLLOWED,
        data
    }
}


// WEBPACK FOOTER //
// ./src/reducers/memberFollowed.js